import React, { useEffect, useState } from 'react';
import { FormControlLabel, Checkbox, TextField, Grid, Button, IconButton } from '@mui/material';
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';
import IndeterminateCheckBoxIcon from '@mui/icons-material/IndeterminateCheckBox';

const TextBoxWithCheckbox = ({ checkpoint,removeCheckpoint,checkpoints,setCheckpoints, id }) => {

  const [text,setText]=useState('')
  const [checked,setChecked]=useState(false)

  useEffect(()=>{
    const cp=checkpoints
    cp[id]={text:text,checkedState:checked}
    setCheckpoints(cp)
  },[text,checked])

  useEffect(()=>{
    setText(checkpoint.text)
    setChecked(checkpoint.checkedState)
  },[])

  const handleRemove=()=>{
    removeCheckpoint(checkpoint)
  }

  return (
    <Grid container  alignItems="center" sx={{mt:2}}>
      
      <Grid item xs={2} sx={{textAlign:'center'}}>
      <IconButton onClick={handleRemove}>
      <IndeterminateCheckBoxIcon color='error'/>

      </IconButton>
      </Grid>

      <Grid item xs={8}>
      
        <TextField
          fullWidth
          label="Checkpoint desc here.."
          value={text}
          onChange={(event) => setText(event.target.value)}
        />
      </Grid>
      <Grid item xs={2} sx={{textAlign:'center'}}>
      <IconButton>
      
          <Checkbox checked={checked} onChange={(event)=>setChecked(!checked)} />
        
      
        </IconButton>
      </Grid>
    </Grid>
  );
};

export default TextBoxWithCheckbox;
